/**
 * 获取token错误
 */
export class TokenError extends Error {
  constructor (error) {
    super(error.message);
    this.name = error.name;
    this.errorType = 'tokenError';
    this.stack = error.stack;
    this.returncode = error.returncode || 0;
    this.detail = error.detail;
  }
}
/**
 * 语音错误
 */
export class RtcError extends Error {
  constructor (result, step) {
    super(result.message);
    this.name = 'rtcError';
    this.result = result.result;
    this.returncode = result.returncode;
    this.errorType = `sound_${step}Error`;
  }
}
/**
 * 语音初始化错误
 */
export class RtcInitError extends RtcError {
  constructor (result) {
    super(result, 'init');
  }
}
/**
 * 语音开始错误
 */
export class RtcStartError extends RtcError {
  constructor (result) {
    super(result, 'start');
  }
}
/**
 * 获取顾问信息错误
 */
export class SalesInfoError extends Error {
  constructor (error) {
    super(error.message);
    this.name = error.name;
    this.errorType = 'salerInfoError';
    this.stack = error.stack;
    this.returncode = error.returncode || 0;
    this.detail = error.detail;
  }
}
/**
 * 呼叫超时错误
 */
export class CallTimeoutError extends Error {
  constructor (timeout, status) {
    super(`${timeout}呼叫超时,当前状态：${status}`);
    this.name = 'CallTimeoutError';
    this.errorType = 'callTimeoutError';
  }
}
/**
 * 频道状态码错误
 */
export class ChannelStatusError extends Error {
  constructor (status) {
    super(`${status}状态码错误`);
    this.statusCode = status;
    this.name = 'ChannelStatusError';
    this.errorType = 'channelStatusError';
  }
}
/**
 * ics端获取加密串错误
 */
export class IcsEncrySalesError extends Error {
  constructor (error) {
    super(error.message);
    this.name = error.name;
    this.errorType = 'icsEncrySalesError';
    this.stack = error.stack;
    this.detail = error.detail;
  }
}
/**
 * 获取用户信息错误
 */
export class UserInfoError extends Error {
  constructor (error) {
    super(error.message);
    this.name = error.name;
    this.errorType = 'userInfoError';
    this.stack = error.stack;
    this.returncode = error.returncode || 0;
    this.detail = error.detail;
  }
}